export default __webpack_public_path__ + "3a89b9f643616686269a0ac985773ee4.jpg";